import { Select, type SelectProps } from '@any-ui-react/core';
import { useEffect, useRef } from 'react';
import { isGroup } from '@/common/components/shared/select/group';

type AllocationSelectInputProps = Omit<SelectProps, 'className'> & {
  autoSelectSingle?: boolean;
};

export const AllocationSelectInput = ({
  autoSelectSingle,
  data,
  value,
  onChange,
  ...props
}: AllocationSelectInputProps) => {
  const valueRef = useRef(value);
  valueRef.current = value;

  useEffect(() => {
    if (!autoSelectSingle || !Array.isArray(data) || data.length !== 1) return;
    const item = data[0];
    if (typeof item !== 'string' && isGroup(item)) return;
    const itemValue = typeof item === 'string' ? item : item.value;
    if (!valueRef.current) {
      onChange?.(itemValue, typeof item === 'string' ? { value: item, label: item } : item);
    }
  }, [autoSelectSingle, data, onChange]);

  return <Select className="flex-1 min-w-48" data={data} value={value} onChange={onChange} {...props} />;
};
